import { Modal } from '@quickbit/qb-design-system';
import { Order } from 'tabs/types';
import { CreateOrderForm } from './CreateOrderForm';

export const CreateOrderModal = ({
  onClose,
  onSuccess,
}: {
  onClose: () => void;
  onSuccess: (arg1: Order) => void;
}) => {
  return (
    <Modal
      title="Create Order"
      closeModal={() => {
        onClose();
      }}
    >
      <CreateOrderForm onSuccess={onSuccess} />
    </Modal>
  );
};
